/* The files this browser tab asked for, by job id, so a file downloads by
 * itself when it is made while the person who asked is still here, as the
 * design standard asks of a tile's file. Kept in memory and outside any
 * component: a My campaigns card that moves to Calling as its file is made
 * is drawn again as a new card, and the job it asked for must still be known.
 * A reload, another tab or another person sees the file's line instead and
 * presses Download. */
const asked = new Set<string>();

export function markAsked(jobId: string): void {
  asked.add(jobId);
}

/** Whether this tab asked for the job, without forgetting it. */
export function wasAsked(jobId: string | null | undefined): boolean {
  return Boolean(jobId && asked.has(jobId));
}

/** True once for a job this tab asked for, so its file downloads once. */
export function takeAsked(jobId: string | null | undefined): boolean {
  return Boolean(jobId && asked.delete(jobId));
}
